import { useAuth } from "../contexts/AuthContext";
import { getDecodedToken } from "../utils/jwtUtils";
import { isCsr } from "../utils/csrAccess";

export function useIsCsr(): boolean {
  const { user } = useAuth();
  const fromUser = user?.roles;
  if (fromUser?.length) return isCsr(fromUser);
  const decoded = getDecodedToken();
  return isCsr(decoded?.roles);
}
